import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { GAnalyticsService } from 'src/app/services/g-analytics.service';
import { MenuCotacaoItem, MenuCotacaoSubItem } from './menu-nova-cotacao';
import { TourStepsService } from 'src/app/services/tour-steps.service';

type ToggleEvents = 'mouseenter' | 'mouseleave' | 'click';
@Component({
    selector: 'app-menu-nova-cotacao',
    templateUrl: './menu-nova-cotacao.component.html',
    styleUrls: ['./menu-nova-cotacao.component.scss'],
    standalone: false
})
export class MenuNovaCotacaoComponent {

  @Input() menusCotacao: MenuCotacaoItem[] = [];
  public isMenuOpen: boolean = false;

  constructor(
    private router: Router,
    private gAnalytics: GAnalyticsService,
    public tourStepsService: TourStepsService
  ) {}

  openPage(item: MenuCotacaoSubItem) {
    this.isMenuOpen = false;
  }
}
